// Interface

import util from '@/utils/classToObject'
import { IMissionVirtualState } from './state'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'

export class MissionVirtualGetter {  
      
  public missionVirtuals(state:IMissionVirtualState,getters:any) {
    return state.missionVirtuals
  }

  public showDialogSimulationFinished(state:IMissionVirtualState,getters:any) {
    return state.showDialogSimulationFinished
  }

  public modifiedAdmMissionVirtual(state:IMissionVirtualState,getters:any) {
    return state.modifiedAdmMissionVirtual
  }

  public originalAdmMissionVirtual(state:IMissionVirtualState,getters:any) {
    return state.originalAdmMissionVirtual
  }

  public missionVirtualLoading(state:IMissionVirtualState,getters:any) {
    return state.missionVirtualLoading
  }

  public missionVirtualsById(state:IMissionVirtualState) {     
    return state.missionVirtuals.reduce((acc,value) =>{
        acc[value.id!] = value
        return acc
    },{}  as {[id:number]:AloDbMissionVirtual})      
  }

  public missionVirtualStatus(state:IMissionVirtualState) {     
    return state.status
  }

  public adminMissionVirtualFilter(state:IMissionVirtualState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(MissionVirtualGetter)